/* eslint-disable max-lines-per-function */
import { MouseEventHandler, ReactNode, useEffect, useState } from 'react';

import { Button, Popover } from '../../index';
import { QuickFilterButton, QuickFilterButtonProps } from '../quick-filter-button/quick-filter-button';

export interface DropdownProps {
  label: ReactNode; // Deprecated, use buttonProps.label instead
  menuContent: ReactNode;
  selectedCount?: number;
  isSelected?: boolean;
  defaultOpen?: boolean;
  icon?: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >; // Deprecated, use buttonProps.icon instead
  applyText?: string;
  resetText?: string;
  onOpen?: () => void;
  onApply?: () => void;
  onReset: () => void;
  renderMenu?: (onApply?: MouseEventHandler<Element>, onReset?: MouseEventHandler<Element>) => React.ReactNode;
  buttonProps?: QuickFilterButtonProps;
}

const options = {
  dropdown: {
    root: 'origin-top-right py-2 absolute z-100',
    base: 'divide-y divide-gray-300 rounded-lg shadow-dark bg-white',
    open: 'block',
    closed: 'hidden',
  },
  container: {
    base: 'flex flex-nowrap items-center box-border rounded-lg border-solid border h-min w-fit cursor-pointer pl-5',
    unselected:
      'border-gray-600 bg-white text-gray-900 hover:text-primary hover:fill-primary active:border-jungle-900 active:fill-jungle-900 active:text-jungle-900',
    selected: 'border-jungle-600 bg-jungle-50 text-jungle-900 fill-jungle-900',
  },
  text: {
    base: 'text-base select-none pr-1',
    selected: '',
    unselected: '',
  },
  icon: {
    base: 'h-6 w-6',
    selected: 'fill-inherit',
    unselected: '',
  },
};

export const Dropdown = (props: DropdownProps) => {
  const {
    label,
    menuContent,
    selectedCount,
    isSelected = false,
    defaultOpen = false,
    applyText = 'Apply',
    resetText = 'Reset',
    onApply,
    onReset,
    renderMenu,
    onOpen,
    buttonProps,
    icon,
  } = props;
  const [menuOpen, setMenuOpen] = useState(defaultOpen);

  useEffect(() => {
    setMenuOpen(defaultOpen);
  }, [defaultOpen]);

  const onClick: MouseEventHandler<HTMLElement> = (e) => {
    e.stopPropagation();
    setMenuOpen((isOpen) => !isOpen);
  };

  const onXClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    setMenuOpen(false);
    onReset();
  };

  const onApplyClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    setMenuOpen(false);
    onApply?.();
  };

  const selectedOption = isSelected || (selectedCount !== undefined && selectedCount > 0);

  return (
    <Popover
      showArrow={false}
      open={menuOpen}
      innerContentClassName=""
      onOpenChange={(isOpen: boolean) => {
        setMenuOpen(isOpen);
        onOpen?.();
      }}
      content={
        renderMenu === undefined ? (
          <div className={options.dropdown.base}>
            <div>{menuContent}</div>
            <div className="flex flex-row px-5 py-2.5">
              <div className="flex-1">
                <Button type="text" onClick={onXClick}>
                  {resetText}
                </Button>
              </div>
              <Button type="primary" onClick={onApplyClick}>
                {applyText}
              </Button>
            </div>
          </div>
        ) : (
          renderMenu(onApplyClick, onXClick)
        )
      }
    >
      <QuickFilterButton
        onClick={onClick}
        isSelected={selectedOption}
        icon={icon}
        label={label}
        onClose={onXClick}
        selectedCount={selectedCount}
        {...buttonProps} // Move it to the bottom to ensure it overrides the other props
      />
    </Popover>
  );
};
export default Dropdown;
